import { render } from "./EnSalads.vue?vue&type=template&id=4305669c&scoped=true"
import script from "./EnSalads.vue?vue&type=script&lang=js"
export * from "./EnSalads.vue?vue&type=script&lang=js"

import "./EnSalads.vue?vue&type=style&index=0&id=4305669c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4305669c"]])

export default __exports__